import axios from "axios";
import { setupInterceptorsTo } from "./interceptors";

export const serverUrl = process.env.REACT_APP_USER_API_URL;

export const HttpService = setupInterceptorsTo(
    axios.create({
        baseURL: serverUrl,
    })
);